var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable @typescript-eslint/no-unsafe-call */
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import useQuery from "../../hooks/use-query";
import Textfield from "syf-component-library/ui/atoms/Textfield";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/pro-light-svg-icons";
import ModalDialog, { DialogTitle, DialogContent, DialogButton, DialogFooter } from "../AlmeDialog/ModalDialog";
const SearchResultItem = styled.div `
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding-left: 16px;
  background-color: #eef6f7;
  border-bottom: solid 1px #9e9e9e;
  min-height: 48px;
  font-weight: bold;
  &:hover {
    background-color: #fff;
  }
`;
const Container = styled.div `
  padding: 1rem;
`;
const SearchResults = styled.div ``;
export function GroupBy(array, key) {
    const map = new Map();
    array.forEach((item) => {
        const itemKey = item[key];
        if (!map.has(itemKey)) {
            map.set(itemKey, array.filter((i) => i[key] === item[key]));
        }
    });
    return map;
}
function SearchItem({ item, handleClick }) {
    return (
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    React.createElement(SearchResultItem, { onClick: () => handleClick(item.SubmitValue) },
        React.createElement("span", { style: { marginLeft: "0.5rem" } }, item.DisplayLabel)));
}
function formSubmitParams(widgetSelection, endType) {
    return ({
        WidgetSelection: widgetSelection,
        endType,
    });
}
const LaunchAutoSearchDialogue = (_a) => {
    var { responseAction } = _a, props = __rest(_a, ["responseAction"]);
    const [query, setQuery] = useState("");
    const { data, loading } = useQuery({ query: query }, responseAction);
    const groupedResults = data && data.length > 0 && GroupBy(data, "DisplayLabel");
    const inputSearchRef = useRef(null);
    const searchBarWrapper = useRef(null);
    const [selectedValue, setSelectedValue] = useState(null);
    const [searchedValue, setSearchedValue] = useState("");
    const [isOpen, setIsOpen] = useState(true);
    useEffect(() => {
        const focusBox = document.getElementById(`alme-search-bar`);
        if (focusBox) {
            setTimeout(() => {
                focusBox.focus();
            }, 10);
        }
    }, []);
    if (!isOpen) {
        return null;
    }
    const onChange = (e) => {
        const val = e.target.value;
        setSearchedValue(val);
        setQuery(val);
    };
    const handleClick = (value) => {
        setSelectedValue(value);
        setSearchedValue(value.DisplayLabel);
        setQuery('');
    };
    const onSubmit = () => {
        const eventName = responseAction === null || responseAction === void 0 ? void 0 : responseAction.ReturnAppEventName;
        const input = selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.SubmitValue;
        if (input) {
            const parameters = formSubmitParams(input, 'Completed');
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            props.onSubmitFormAppEvent(eventName, parameters, 'Internal');
            setIsOpen(false);
        }
    };
    const onCancel = () => {
        const eventName = responseAction === null || responseAction === void 0 ? void 0 : responseAction.ReturnAppEventName;
        const parameters = formSubmitParams('Aborted', 'Aborted');
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        props.onSubmitFormAppEvent(eventName, parameters, 'Internal');
        setIsOpen(false);
    };
    const onNotFound = () => {
        const eventName = responseAction === null || responseAction === void 0 ? void 0 : responseAction.ReturnAppEventName;
        const parameters = formSubmitParams('PSCC', 'Completed');
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        props.onSubmitFormAppEvent(eventName, parameters, 'Internal');
        setIsOpen(false);
    };
    return (React.createElement(Container, { ref: searchBarWrapper, onClick: () => inputSearchRef.current && inputSearchRef.current.focus() },
        React.createElement(ModalDialog, { id: 'data-collection-dialog-title', ariaLabel: "Auto Search Box", header: React.createElement(DialogTitle, { id: "data-collection-dialog-title" }, responseAction.TitleText), footer: React.createElement(DialogFooter, null,
                React.createElement(DialogButton, { id: 'submit-button', buttonType: 'primary', onClick: onSubmit }, "Submit"),
                React.createElement(DialogButton, { id: 'cancel-button', buttonType: 'ghost', onClick: onCancel }, "Cancel"),
                React.createElement(DialogButton, { id: 'notFound-button', buttonType: 'ghost', onClick: onNotFound }, responseAction.NotFoundButtonText)) },
            React.createElement(DialogContent, null,
                React.createElement(Textfield, { id: `alme-search-bar`, autoCapitalize: "none", name: "client", maxLength: 17, placeholder: `Search here...`, width: "275px", required: true, type: "text", value: searchedValue, onChange: onChange, textfieldRef: inputSearchRef, leftIcon: React.createElement(FontAwesomeIcon, { icon: faSearch }), className: "iva-text-input-field-container", inputClassName: "iva-text-input-field", showMaskedOption: false }),
                isOpen && (loading ? React.createElement("p", null, "Loading....") : query) && (React.createElement(SearchResults, null, groupedResults &&
                    Array.from(groupedResults.entries()).map((item, ix) => {
                        return (React.createElement("div", { key: ix, style: {
                                borderTop: `${groupedResults.size > 1 ? "0" : "solid 0.1rem #d8dae5"}`,
                            } }, data.map((its, iy) => (React.createElement(SearchItem, { handleClick: () => handleClick(its), item: its, key: iy })))));
                    })))))));
};
export default LaunchAutoSearchDialogue;
